import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Box, Button, Icons } from '@curves/ui-base';
import { useMainLayoutContext } from '@Local/Components/Layout/Context/MainLaydoutContext';
import { FOOTER_TYPE, HEADER_TYPE, THEME_TYPE } from '@Constants/dataEnums';
import { MEMBER_REDEEM_ROUTER } from '@Router/routerPath';
import { PointsSummaryBox, RedeemHistoryList } from '@Local/Redeem/Components';
import useRedeemHistory from '@Local/Redeem/hooks/useRedeemHistory';
import useMemberRedeemApi from '@Apis/useMemberRedeemApi';

const RedeemHistoryPage = () => {
    const { setHeaderType, setFooterType, setThemeType } = useMainLayoutContext();
    const { monthGroups, hasMore, loadMore } = useRedeemHistory();
    const { getRewardApi } = useMemberRedeemApi();
    const history = useHistory();

    const [reward, setReward] = useState(null);

    const handleBack = () => history.push(MEMBER_REDEEM_ROUTER);

    useEffect(() => {
        setHeaderType(HEADER_TYPE.DEFAULT);
        setFooterType(FOOTER_TYPE.HIDE);
        setThemeType(THEME_TYPE.DARK);
    }, [setHeaderType, setFooterType, setThemeType]);

    useEffect(() => {
        getRewardApi().then((resp) => {
            if (resp) setReward(resp);
        });
        // eslint-disable-next-line
    }, []);

    return (
        <Box className="redeem-history-page">
            <Box className="history-page-header">
                <Button
                    className="history-back-btn"
                    startIcon={<Icons.KeyboardArrowLeft />}
                    onClick={handleBack}
                >
                    返回
                </Button>
            </Box>
            <Box className="container">
                <PointsSummaryBox currentPoints={reward?.currentPoints} />
                <RedeemHistoryList
                    monthGroups={monthGroups}
                    hasMore={hasMore}
                    onLoadMore={loadMore}
                />
            </Box>
        </Box>
    );
};

export default RedeemHistoryPage;
